if (!customElements.get('sticky-announcement')) {
  customElements.define('sticky-announcement', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.announcement-bar-section');
      this.updateHeight = () => {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.section.offsetHeight}px`);
      };
      this.observer = new ResizeObserver(this.updateHeight);
      this.observer.observe(this.section);
      this.updateHeight();
    }

    disconnectedCallback() {
      this.observer.disconnect();
      document.documentElement.style.removeProperty('--announcement-bar-height');
    }
  });
}
